import React from 'react';
import AuthService from './authService.js';
import ClientInvoiceLineItem from '../Domain/ClientInvoiceLineItem.js';
import SearchParams from '../Elements/SearchParams';
import ClientInvoiceLineItemSearchParams from '../Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceLineItemSearchParams';

export default class VZeusLineItemOpenService extends React.Component {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ClientInvoiceLineItemSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/VZeusLineItemOpen/GetLineItemsForClientInvoiceAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ClientInvoiceLineItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ExportToExcel(searchItem) {
    const searchParams = new SearchParams(searchItem, ClientInvoiceLineItemSearchParams, '', '', 0, 0);
    return AuthService.getInstance().CallBackendFunction(
      `/api/VZeusLineItemOpen/ExportToExcelAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=false`
    );
  }
}
